import { useQuery } from '@tanstack/react-query';

import { SearchReleasedBatchesByNamesResponse } from '@e-origin/contracts';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchNames: string;
}

export const searchReleasedBatchesByNames = async (batchNames: string): Promise<SearchReleasedBatchesByNamesResponse> => {
  try {
    const result = await apiClient.batchesArchive.searchReleasedBatchesByNames.query({ query: { names: batchNames } });
    if (result.status !== 200) throw result.body;

    return result.body.data;
  } catch (error) {
    showErrorToast(error, 'Error searching the batch name!');
  }
};

export const useReleasedBatchesByNames = ({ batchNames }: HookProps) =>
  useQuery({
    queryKey: ['batches', batchNames],
    queryFn: () => searchReleasedBatchesByNames(batchNames),
    placeholderData: [],
  });
